module.exports = __webpack_public_path__ + "static/skitrip1-b54b056050f46e49b493ac12eea5c98a.jpg";